// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__vYhOu","buttons":"styles_buttons__Ns9l-"};